/**
 * uid-scoped localStorage mark recording that a rejected or waitlisted
 * student has seen the referral ask. Those screens show on every login, so
 * without a mark the ask would greet them every time. (On-hold students see
 * the ask inside the one-time success plan deck and don't need it.)
 *
 * Same trade-off as `src/features/referrals/utils/referralOnboardingMarks.ts`:
 * a cleared cache or a new device shows the ask once more. Storage failures
 * degrade to "not seen".
 */

const KEY_PREFIX = "referrals.applicationResultAskSeen";

function buildKey(uid: string): string {
  return `${KEY_PREFIX}.${uid}`;
}

export function hasSeenApplicationResultAsk(uid: string): boolean {
  try {
    return window.localStorage.getItem(buildKey(uid)) !== null;
  } catch {
    return false;
  }
}

export function markApplicationResultAskSeen(uid: string): void {
  try {
    window.localStorage.setItem(buildKey(uid), new Date().toISOString());
  } catch {
    // Best effort: a failed write means the ask may show once more.
  }
}
